import { type BACKGROUND_COLORS_VALUES, COLORS } from '@alto/design-library-tokens';

/**
 * FuzeRx surfaces (PH-4256).
 *
 * The Fuze color system was mapped onto the existing tokens one-for-one, which left neutral chrome —
 * page sections, hovered rows, selected options — painted with brand-tinted greens. Design's rule is
 * that those surfaces are warm greys, and colour is reserved for states that mean something (warning,
 * danger, success).
 *
 * Each helper is a function rather than a constant because `COLORS` is applied at runtime by
 * `applyDesignBrand`; reading it at module load would capture the wrong palette.
 */

/** A neutral page or section surface. */
export const getNeutralSurfaceColor = (): BACKGROUND_COLORS_VALUES => COLORS.BACKGROUND_COLORS.GREY_LIGHTEST;

/** Background of a clickable row while hovered or pressed (`ListItem`, `ListHeader`, nav rows). */
export const getInteractiveSurfaceColor = (): BACKGROUND_COLORS_VALUES => COLORS.BACKGROUND_COLORS.GREY_LIGHTEST;

/** Background of a selected row (a checked radio option, an active list item). */
export const getSelectedSurfaceColor = (): BACKGROUND_COLORS_VALUES => COLORS.BACKGROUND_COLORS.GREY;
